var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm.mode === "email"
      ? _c("div", { staticClass: "col-lg-7 offset-lg-2" }, [
          _c("div", { staticClass: "card p-5" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.sent
                  ? [
                      _c(
                        "h4",
                        { staticClass: "fw-semibold text-center mb-3" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("translate")("Send verification code")
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-4 text-center" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("translate")(
                                "The verification code will be sent to your email address used for login"
                              )
                            ) +
                            ".\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-dark px-4 btn-sm fw-semibold",
                            attrs: {
                              disabled: _vm.sending || _vm.resendLocked,
                            },
                            on: { click: _vm.sendCode },
                          },
                          [
                            _vm.sending
                              ? _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.resendLabel) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : _c("div", { staticClass: "text-center" }, [
                      _c("h4", { staticClass: "fw-semibold mb-3" }, [
                        _vm._v(
                          _vm._s(_vm._f("translate")("Enter verification code"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-label mb-4",
                          attrs: { for: "email-code" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("translate")(
                                  "We have just sent a message to your email address"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code,
                            expression: "code",
                          },
                        ],
                        staticClass:
                          "form-control w-50 mx-auto d-block mb-4 text-center",
                        class: { "is-invalid": _vm.codeError },
                        attrs: {
                          id: "email-code",
                          type: "text",
                          pattern: "[0-9]*",
                          inputmode: "numeric",
                          maxlength: "6",
                          autocomplete: "one-time-code",
                        },
                        domProps: { value: _vm.code },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.code = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark btn-sm px-4 fw-semibold",
                          attrs: { disabled: _vm.verifying },
                          on: { click: _vm.verifyCode },
                        },
                        [
                          _vm.verifying
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm",
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("translate")("Verify")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link px-0 text-muted",
                            attrs: {
                              type: "button",
                              disabled: _vm.resendLocked,
                            },
                            on: { click: _vm.resendCode },
                          },
                          [
                            _vm.resendLocked
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("my.waitx", { x: _vm.resendTimer })
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.$t("Resend code"))),
                                ]),
                          ]
                        ),
                      ]),
                    ]),
              ],
              2
            ),
          ]),
        ])
      : _vm.mode === "phone"
      ? _c("div", { staticClass: "col-lg-7 offset-lg-2" }, [
          _c("div", { staticClass: "card p-5" }, [
            _c("div", { staticClass: "card-body" }, [
              !_vm.hasPhone
                ? _c("div", [
                    _c("h4", { staticClass: "fw-semibold text-center mb-3" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("translate")(
                              "Please enter your phone number to verify your account"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4 text-center" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("translate")(
                              "This number will be used to send one-time login codes"
                            )
                          ) +
                          ".\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.prefix,
                                expression: "prefix",
                              },
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "+####",
                                expression: "'+####'",
                              },
                            ],
                            staticClass: "form-control me-2 text-end",
                            class: { "is-invalid": _vm.phoneError },
                            staticStyle: { width: "80px", flex: "0 0 auto" },
                            attrs: {
                              type: "text",
                              inputmode: "numeric",
                              maxlength: "4",
                              autocomplete: "tel-country-code",
                            },
                            domProps: { value: _vm.prefix },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.prefix = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phone,
                                expression: "phone",
                              },
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "#############",
                                expression: "'#############'",
                              },
                            ],
                            staticClass: "form-control",
                            class: { "is-invalid": _vm.phoneError },
                            staticStyle: {
                              flex: "1 1 auto",
                              "max-width": "200px",
                            },
                            attrs: {
                              id: "phone",
                              type: "tel",
                              placeholder: "500123456",
                              autocomplete: "tel-national",
                              inputmode: "numeric",
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.phone = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.phoneError
                        ? _c("div", { staticClass: "text-center" }, [
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("validation.required")
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark px-4 btn-sm fw-semibold",
                          attrs: { disabled: _vm.savingPhone },
                          on: { click: _vm.savePhone },
                        },
                        [
                          _vm.savingPhone
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm",
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("translate")("Send verification code")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : !_vm.sent
                ? _c("div", [
                    _c("h4", { staticClass: "fw-semibold text-center mb-3" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Send verification code"))
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.hasPhoneLocal && _vm.lastThreeLocal
                      ? _c("div", { staticClass: "mb-3 text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("translate")(
                                  "The verification code will be sent to your phone number"
                                )
                              ) +
                              "\n            "
                          ),
                          _c("strong", [
                            _vm._v("*** *** " + _vm._s(_vm.lastThreeLocal)),
                          ]),
                          _vm._v("\n            .\n          "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark px-4 btn-sm fw-semibold",
                          attrs: { disabled: _vm.sending || _vm.resendLocked },
                          on: { click: _vm.sendCode },
                        },
                        [
                          _vm.sending
                            ? _c("span", {
                                staticClass: "spinner-border spinner-border-sm",
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.resendLabel) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "text-center" }, [
                    _c("h4", { staticClass: "fw-semibold mb-3" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Enter verification code"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "phone-code" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("translate")(
                                  "We have just sent a message to the phone number"
                                )
                              ) +
                              "\n              "
                          ),
                          _c("strong", [
                            _vm._v("*** *** " + _vm._s(_vm.lastThreeLocal)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code,
                            expression: "code",
                          },
                        ],
                        staticClass:
                          "form-control w-50 mx-auto d-block text-center",
                        class: { "is-invalid": _vm.codeError },
                        attrs: {
                          id: "phone-code",
                          type: "text",
                          pattern: "[0-9]*",
                          inputmode: "numeric",
                          maxlength: "6",
                          autocomplete: "one-time-code",
                        },
                        domProps: { value: _vm.code },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.code = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.codeError
                        ? _c("div", { staticClass: "text-center" }, [
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("validation.required")
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dark btn-sm px-4 fw-semibold",
                        attrs: { disabled: _vm.verifying },
                        on: { click: _vm.verifyCode },
                      },
                      [
                        _vm.verifying
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("translate")("Verify")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link px-0 text-muted",
                          attrs: { type: "button", disabled: _vm.resendLocked },
                          on: { click: _vm.resendCode },
                        },
                        [
                          _vm.resendLocked
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("my.waitx", { x: _vm.resendTimer })
                                  )
                                ),
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("Resend code"))),
                              ]),
                        ]
                      ),
                    ]),
                  ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }